import { Component, OnInit }  from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { environment } from "../../../../environments/environment";
import { CmsService } from 'src/app/Services/cms.service';
import { Router } from "@angular/router";
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
    selector: 'app-planeador-viagens',
    templateUrl: './planeador-viagens.component.html',
    standalone: false
})
export class PlaneadorViagensComponent implements OnInit{
  language: string = '';
  defaultLanguage: string = environment.defaultLanguage;
  planTrip_content: string = 'linhas-planeador';
  planTripInfo: any = {};
  youtubeEmbedUrl?: SafeResourceUrl;

  isLandscape = false; // true if 9:16, false if 16:9

  constructor(
    private cmsService: CmsService,
    private router: Router,
    private translate: TranslateService,
    private title: Title,
    private sanitizer: DomSanitizer
  ) {
    let lang = localStorage.getItem('language') ?? this.defaultLanguage;
    this.language = lang.split('-')[0];

    this.translate.get('navLinks').pipe().subscribe(trans => {
      let pageTitle =  trans['linhas'] + ' | ' + trans['planeador']
      this.title.setTitle(pageTitle);
    })
  }

  ngOnInit(){
    this.getContent();
  }

  getContent(){
    this.cmsService.getContentList(this.planTrip_content, this.language).subscribe(
      {
        next: data => {
          this.planTripInfo = data['body']['data'];

          if(this.planTripInfo.Video_16_9 == null || this.planTripInfo.Video_9_16 == null) return;

          const width = window.innerWidth;
          const height = window.innerHeight;
          const screenRatio = width / height;
          
          this.isLandscape = screenRatio >= 1;
          
          const url = screenRatio >= 1 ? this.planTripInfo.Video_16_9 : this.planTripInfo.Video_9_16;
          const videoId = screenRatio >= 1 ? url.split('v=')[1]?.split('&')[0] : url.split('/shorts/')[1]?.split('?')[0];
          if (videoId) {
            const embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=0&mute=1&loop=1&playlist=${videoId}`;
            this.youtubeEmbedUrl = this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl);
          }  
        },
        error: er => {
          this.router.navigate(['/500']);
        }
      }
    );
  }
}
